import { render, staticRenderFns } from "./accredit.vue?vue&type=template&id=cbf66068&scoped=true&"
import script from "./accredit.ts?vue&type=script&lang=js&"
export * from "./accredit.ts?vue&type=script&lang=js&"
import style0 from "./accredit.less?vue&type=style&index=0&id=cbf66068&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbf66068",
  null
  
)

export default component.exports